"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("./utils");
var plural = _utils.plural_en;
var url = {
  register: '/ru/?register',
  help: '/ru/aide',
  contact: '/ru/contact'
};
var _default = exports["default"] = {
  _code: 'ru',
  path: '/ru',
  url: url,
  male: 'Male',
  female: 'Female',
  couple: 'Couple',
  transvestite: 'Transvestite',
  gender_to_str: function gender_to_str(gender) {
    switch (parseInt(gender)) {
      case 1:
        return this.male;
      case 2:
        return this.female;
      case 3:
        return this.couple;
      case 4:
        return this.transvestite;
      default:
        return '';
    }
  },
  photo_deleted: 'фотография удалена',
  help: 'Help',
  creator_: 'Creator:',
  colon: ': ',
  rooms: 'Rooms',
  main_room: 'Main room',
  minimize_pm: 'Minimize',
  private_messages: 'Private messages',
  active_contacts: 'Active',
  all_contacts: 'All',
  functions_xxl_text: '<h2>Access XXL features</h2>' + '<p>Single period, without automatic rebilling. Immediate access.</p>' + '<ul>' + '<li>Viewing all webcams without limits</li>' + '<li>Full-screen viewing of webcams</li>' + '<li>Private messages (PM) feature in chat rooms</li>' + '<li>Private room creation</li>' + '<li>Access to full rooms</li>' + '<li>All features in the mail</li>' + '<li>All features of the profile page</li>' + '<li>Access to all amateur films</li>' + '<li>Access to all photos</li>' + '<li>Blocking unwanted users</li>' + '<li>Participation in collective moderation</li>' + '</ul>' + '<p>...and a lot more.</p>' + '<a href="/bobtv-xxl" target="_blank">Become a member</a>',
  functions_xxl_link: '<span class="xxl-logo en" title="XXL"/> Functions',
  new_message: 'New message',
  new_messages: 'New messages',
  text_editor_stub_anonymous: 'Your anonymous session time is limited to 10 minutes. <a class="anonymous-link-login">Sign in</a> or <a class="anonymous-link-register">register</a> to participate in the chat.',
  noncertified_full: 'To write on the chat you must be <a href="/en/bobtv-xxl" target="_blank">XXL member</a> or certify your account <a class="link-activate-by-sms">by SMS</a>.',
  certification_disabled: 'To write on the chat you must be <a href="/en/bobtv-xxl" target="_blank">XXL member</a>.',
  streaming_control_tooltip: 'Show or hide the window of your webcam. <br/>Your video is visible to everyone permanently.',
  placeholder: 'Написать сообщение...',
  attachment_tooltip: 'Отправить изображение в формате .JPG',
  send: 'Отправить',
  token0: 'tokens',
  token: 'token',
  tokens: 'tokens',
  pm_tokens: 'private tokens',
  sending_token: ' token sent',
  sending_tokens: ' tokens sent',
  users: 'Users',
  users_online: 'users online',
  watch_top: 'Watch top',
  sort_by: 'Sort by:',
  sort_by_name: 'Alphabetically',
  sort_by_gender: 'Gender',
  sort_by_watching: '"Who\'s watching me"',
  sort_by_followees: 'Followed by me',
  sort_by_status: 'Status',
  watch: 'Watch',
  private_message: 'Private message',
  view_profile: 'View profile',
  follow: 'Follow',
  unfollow: 'Unfollow',
  deleteHistory: 'Delete PM history',
  pm_history_deleted: function pm_history_deleted(user) {
    return "Messages have been removed ".concat(user ? "by ".concat(user) : "");
  },
  gift_sender_anonymous: 'Anonymous',
  offered_virtual_gift_to: 'has given this virtual gift to',
  give_tokens_to: function give_tokens_to(value) {
    return "gives ".concat(value, " ").concat(value > 1 ? 'tokens' : 'token', " to");
  },
  sent_new_wall_post: 'has posted at',
  the_wall: 'the Wall',
  donate_info_title: 'Record of given tokens',
  donate_info_pm: 'Tokens offered in private are not notified on the general chat.',
  donate_info_body: function donate_info_body(sender, receiver, amount) {
    return "<a href=\"/profil/".concat(sender, "\" target=\"_blank\">@").concat(sender, "</a> sent ").concat(amount, " tokens to <a href=\"/profil/").concat(receiver, "\" target=\"_blank\">@").concat(receiver, "</a> on ");
  },
  failed_streaming: 'Failed to start video streaming.<br/>Please check your web camera or browser permissions.',
  opening_video: 'Opening video...',
  message_me_blocked: function message_me_blocked(user) {
    return 'Sorry, you are blocked by&nbsp;<span class="nick">' + (0, _utils.escape)(user.nick) + '</span> <span class="type h24">for 24 hours</span><span class="type permanent">permanently</span>.<br/>You cannot see chat messages, view video and send private messages.';
  },
  message_video_paused: 'Paused',
  message_user_blocked: function message_user_blocked(user) {
    return '<span class="nick">' + (0, _utils.escape)(user.nick) + '</span> is blocked by you and can not exchange private messages with you.';
  },
  message_user_offline: 'Video stream lost',
  message_limit_reached: 'Sorry, your free watching time has expired.<br/><a href="/en/bobtv-xxl" target="_blank">Become an XXL user</a> to watch multiple webcams with no time limits.',
  message_please_register: 'Please register to watch video',
  block: 'Block',
  block_confirm: function block_confirm(user) {
    return '<strong>Do you want to block <span class="nick">' + (0, _utils.escape)(user.nick) + '</span>?</strong><br/><br/><em><span class="nick">' + (0, _utils.escape)(user.nick) + '</span> would not be able to <nobr>read you</nobr>, <nobr>watch you</nobr> and send you private messages.<br/>Do not block without sufficient reason!</em>';
  },
  block_placeholder: 'Reason of blacklisting',
  block_24h: '24 hours',
  block_permanent: 'permanently',
  block_no: 'no',
  unblock: 'Unblock',
  unblock_confirm: function unblock_confirm(user) {
    return 'Do you want to unblock <span class="nick">' + (0, _utils.escape)(user.nick) + '</span>?';
  },
  mute_one_hour: 'Click to mute one hour',
  unmute_one_hour: 'Click to unmute',
  fullscreen_confirm: 'For better user experience you can switch to Fullscreen mode.',
  fullscreen_yes: 'Switch',
  fullscreen_forget: 'Do not ask me again',
  exclude: 'Exclude from chat',
  ban: 'Ban',
  give_virtual_gift: 'Give a virtual gift',
  give_xxl: 'Give a XXL',
  revoke_pm: 'Revoke PM permission',
  close_pm: 'Close this PM',
  pm_not_allowed_text: function pm_not_allowed_text(user) {
    return "\u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043B\u0438\u0447\u043D\u0443\u044E \u043F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0443 <br>\u0441 ".concat((0, _utils.escape)(user.nick), "?");
  },
  yes: 'Yes',
  no: 'No',
  pm_pending_text: function pm_pending_text(user) {
    return 'Пожалуйста, дождитесь пока ' + (0, _utils.escape)(user.nick) + '<br/>примет ваш запрос.';
  },
  pm_pending_text_payment: "Пользователи купившие премиум могут начать разговор, не дожидаясь согласия получателя.",
  pm_request_cancel: 'Отменить',
  pm_request_premium: 'Стать Премиум-участником',
  pm_requested_text: function pm_requested_text(user) {
    return (0, _utils.escape)(user.nick) + ' хочет начать личную переписку<br/>с вам. Вы согласны?';
  },
  agree: 'Согласен',
  refuse: 'Отклонить',
  pm_rejected_text: function pm_rejected_text(user) {
    return 'Извините, ' + (0, _utils.escape)(user.nick) + ' отклонил ваш запрос<br/>на личную переписку.';
  },
  pm_revoked_text: 'PM permission is revoked.',
  pm_revoked_or_denied_by_me_text: function pm_revoked_or_denied_by_me_text(user) {
    return 'Вы не приняли запрос на личную пересписку от ' + (0, _utils.escape)(user.nick) + '. Хотите отобрить личную переписку сейчас?';
  },
  pm_user_connected: function pm_user_connected(user, chatrooms) {
    var chatrooms_str = "";
    if (chatrooms) {
      chatrooms_str = " in " + user.chatrooms.join(", ");
    }
    return (0, _utils.escape)(user.nick) + " is connected" + chatrooms_str + ".";
  },
  pm_user_disconnected: function pm_user_disconnected(user) {
    return (0, _utils.escape)(user.nick) + " is disconnected.";
  },
  user_disconnected: function user_disconnected(user) {
    return "offline";
  },
  info_age: 'Age:',
  info_years: function info_years(user) {
    return user.age ? parseInt(user.age) + (user.age > 1 ? ' years' : ' year') : '—';
  },
  info_country: 'Country:',
  info_region: 'Region:',
  info_gender: 'Gender:',
  info_male: 'male',
  info_female: 'female',
  info_couple: 'couple',
  info_trans: 'transvestite',
  info_camera: 'Camera:',
  info_watching: 'Watching:',
  info_certified_no: 'Censored for 1 hour',
  info_cannot_write: 'Cannot write',
  info_status: 'Status:',
  info_online: 'Online:',
  info_yes: 'yes',
  info_no: 'no',
  info_status_anonymous: 'visitor',
  info_status_free: 'free',
  info_status_xxl: 'XXL',
  upload_general_error: 'Upload general error.',
  fancybox_prev: 'Previous',
  fancybox_next: 'Next',
  fancybox_close: 'Close',
  fancybox_error: 'The requested content cannot be loaded.<br/>Please try again later.',
  create_new_room: 'Create new room',
  refreshing_room_list: 'Refreshing...',
  room_name: 'Room name',
  with_password: 'With password',
  your_password: 'Your Password',
  create: 'create',
  please_wait: 'Please wait...',
  create_room_error_name_empty: 'Please enter a name of new room.',
  create_room_error_room_exists: 'A room with such name already exists.',
  create_room_error_password_empty: 'Please provide a password.',
  create_room_error_passwords_not_match: 'Password and its confirmation don\'t match.',
  create_room_error_xxl: 'You need to become an <a href="/en/bobtv-xxl" target="_blank">XXL member</a> to create rooms.',
  create_room_error_general: 'Cannot create new room, please try again later.',
  entering_chat_room: 'Entering chat room...',
  reconnection_message: 'Connection with chat room have been lost.<br/>Reconnection...',
  disconnected_message: 'You have been disconnected.',
  reconnect: 'Reconnect',
  already_connected: 'You are already connected to the room with a first device, do you want to connect a second device?',
  supported_browsers: 'To be able to connect this chat room you must use <a href="https://www.google.com/chrome/index.html" target="_blank">Google Chrome</a>, <a href="https://support.apple.com/downloads/safari">Safari</a>, <a href="https://www.mozilla.org/firefox/new/" target="_blank">Mozilla Firefox</a> or <a href="http://www.opera.com/download" target="_blank">Opera</a> browser on Windows, MacOS&nbsp;X or smartphone/tablet with Android.<br/>' + 'Only Safari is currently compatible on iPhone and iPad with iOS version 12.2 and above.',
  firefox_esr: '<strong>Firefox ESR</strong> is no longer supported by <strong>BobTV room</strong>.<br/>Please use latest versions of <a href="https://www.mozilla.org/firefox/new/" target="_blank">Firefox</a>, <a href="https://www.google.com/chrome/index.html" target="_blank">Google Chrome</a> or <a href="http://www.opera.com/download" target="_blank">Opera</a>.',
  become_xxl_to: 'You must become <a href="/en/bobtv-xxl" target="_blank">XXL user</a> to&nbsp;',
  you_must_be_xxl: 'You must be XXL member to use this feature.',
  xxl_feature: 'use this feature',
  xxl_fullscreen: 'view videos in fullscreen mode',
  xxl_pm: 'send private messages',
  xxl_exclude: 'request an exclusion',
  xxl_block: 'block a user',
  xxl_follow: 'follow a user',
  xxl_create_room: 'create a room',
  xxl_attach_photo: 'send your photo to chat',
  close: 'Close',
  cancel: 'Cancel',
  logged_out: 'You have been disconnected. Please re-login to connect again.',
  relogin: 're-login',
  please_login: 'Please log in to use this function.',
  you_have_reached_visitors_limit: 'You have reached anonymous visitor\'s time limit. Please log in or register to continue.',
  login: 'login',
  activation: 'Activation',
  nick: 'Nick',
  email: 'Email',
  nick_or_email: 'Nick or Email',
  guest: 'Anonymous',
  code: 'Code',
  receive_password: 'Receive password',
  closed_room: 'Closed room',
  please_provide_password_for_room: function please_provide_password_for_room(room) {
    return 'Please provide a password to enter room <span class="room-name">' + (0, _utils.escape)(room) + '</span>.';
  },
  password: 'Password',
  wrong_password: 'You have entered the wrong password.',
  forgot_password: 'Forgot password?',
  password_confirm: 'Confirm password',
  enter: 'Enter',
  close_room_confirm: function close_room_confirm(room) {
    return 'Do you want to close room <span class="room-name">' + (0, _utils.escape)(room) + '</span>?';
  },
  room_closed_message: function room_closed_message(room) {
    return 'The room <span class="room-name">' + (0, _utils.escape)(room) + '</span> has closed.';
  },
  personal_room_closed_message: function personal_room_closed_message(room) {
    return 'This <strong>My BobTV</strong> room has closed.';
  },
  enter_main_room: 'Enter main room',
  room_info_created_by: 'Created by',
  room_info_there_is: 'There is',
  DHM: ["d", "h", "m"],
  exclude_user: 'Exclude user',
  exclude_confirm: function exclude_confirm(user) {
    return "You are going to request exclusion of ".concat(user.nick, ".");
  },
  exclude_placeholder: 'Details for Bob',
  exclude_placeholder_other: 'Other reason',
  exclude_reason: 'Why do you want to exclude this user?',
  exclude_information: ['This room is moderated collectively by all XXL members.', 'You can exclude a user who does not comply with the CGU (TOS) by using the form above.', 'The system manages your requests of exclusion immediately and blocks the user for a period of 24 hours or more.', 'It is essential that all XXL are involved in collective moderation so that mood of the room is the best possible and that the CGU are respected.'],
  block_user_excluded: function block_user_excluded(user) {
    return (0, _utils.escape)(user.nick) + ' is excluded because of disrespecting the CGU.';
  },
  block_user_excluded_personal: function block_user_excluded_personal(user) {
    return (0, _utils.escape)(user.nick) + ' is excluded from this My BobTV room.';
  },
  site_interface_generic_error: 'Sorry, an error has occured. Please try again later.',
  post_payment_text: "<strong>Congratulations!</strong><br/>You have become an XXL member and all site functions are available to you.<br/>Happy chatting!",
  too_many_users_popup: function too_many_users_popup(chatroomName) {
    return (0, _utils.escape)(chatroomName) + " room is full, only XXL members are allowed to enter.";
  },
  become_xxl: "Become XXL",
  excluded_blocked_popup: function excluded_blocked_popup(_ref) {
    var date = _ref.date,
      reason = _ref.reason;
    return 'Your access to BobTV rooms is blocked until&nbsp;<em>' + date + '</em>.' + (reason ? '<br/><br/><strong>Block reason:</strong><br/><pre>' + reason + '</pre>' : '');
  },
  excluded_room_popup: function excluded_room_popup(_ref2) {
    var date = _ref2.date,
      room = _ref2.room,
      reason = _ref2.reason;
    return 'You are excluded from room <strong>' + (0, _utils.escape)(room.name) + '</strong> until&nbsp;<em>' + date + '</em>.' + (reason ? '<br/><br/><strong>Exclusion reason:</strong><br/><pre>' + reason + '</pre>' : '');
  },
  blacklisted_popup: function blacklisted_popup(_ref3) {
    var nick = _ref3.nick;
    return 'You are blocked by <strong>' + (0, _utils.escape)(nick) + '</strong> and cannot enter My BobTV room.';
  },
  get invalid_gender_for_gays_room() {
    var self = this;
    return function (_ref4) {
      var gender = _ref4.gender;
      return 'Sorry this room is restricted to Men. Your gender is <strong>&quot;' + self.gender_to_str(gender) + '&quot;</strong>, you may not enter.';
    };
  },
  insufficient_funds: 'Insufficient funds',
  nonexistent_room_popup: 'Sorry, this My BobTV room does not exist',
  not_enough_jetons_popup_title: 'Your token balance',
  not_enough_jetons_popup_message: 'You do not have enough tokens at your virtual wallet',
  not_enough_jetons_popup_button: 'Replenish',
  has_opened_mybobtv_room: 'has opened a room My BobTV',
  has_started_mybobtv_showroom: 'has started a showroom My BobTV',
  join_this_room: 'join this room',
  join_show: 'Join show',
  showroom_welcome: function showroom_welcome(nick) {
    return nick + ' welcomes you in the room My | Show.';
  },
  showroom_price: function showroom_price(price) {
    return 'Your account will be charged for ' + plural(price, 'token', 'tokens') + ' per minute.';
  },
  replenish_your_wallet: 'Replenish your wallet',
  your_tokens_amount: function your_tokens_amount(amount) {
    return 'Your wallet amount is ' + amount + ' ' + plural(amount, 'token', 'tokens') + '.';
  },
  edit_my_room: "Edit my room",
  showroom_price_input: 'MY | SHOW price, tokens per minute',
  activate_showroom: 'Activate MY | SHOW',
  showroom_price_buttons_tooltip: 'Number of tokens collected per minute from each user',
  base_lib_not_loaded: 'Connection to the room takes too much time. Maybe the room is offline or there is an issue with your connection.<br/><br/>Please wait a little more or try to refresh page or visit another room.<br/><br/>If the the problem persists, <a href="/en/contact" target="_blank">contact Bob<a/>',
  register: 'Register',
  anonymous_login: 'Trial login',
  specify_a_nick: 'Please specify a nick',
  anonymous_login_error_generic: 'Sorry, you cannot enter room by now, please try again later.',
  anonymous_login_error_user_exists: 'This nick is already in use, please try another one.',
  anonymous_login_error_invalid_characters: 'Your nick should contain only letters or numbers.',
  // settings window
  settings: 'Settings',
  camera: 'Camera',
  microphone: 'Microphone',
  voice_processing: 'Voice processing',
  audio_filter: 'Audio filter',
  voice: 'Voice (microphone)',
  music: 'Music (sound card)',
  apply: 'Apply',
  save_settings: 'Save settings',
  quality: 'Your own video quality',
  quality_description: 'Adjust quality of your own video.',
  quality__240p: '240p - Low (320x240)',
  quality__360p: '360p - Medium (480x360)',
  quality__480p: '480p - Standard (640x480)',
  quality__720p: '720p - (960x720)',
  quality__720hd: '720p HD - High definition (1280x720)',
  click: 'Click',
  allow: 'Allow',
  camera_access_right_notheme: function camera_access_right_notheme(statusMiddle) {
    return statusMiddle ? 'Click on' : 'or click on';
  },
  camera_access_right_theme: 'to use your webcam and your microphone.',
  tab_general: 'General',
  tab_media: 'Media',
  tab_sound: 'Sound',
  your_mood: 'Your mood',
  pm_request: "New pm request sound",
  pm_message: "New pm message sound",
  new_tip: "New tip sound",
  mood: 'Mood',
  show_your_mood: "Show your mood",
  offline: 'offline',
  right_point_info: 'The collected tokens can be used for purchasing the virtual gifts and for ordering at Bobstore. <a href="/membre/wallet/replenish" target="_blank">Replenish</a>',
  cgu_roll_up: 'Roll up...',
  cgu_read_more: 'Read more...',
  cgu_title: 'Welcome to BobTV!',
  cgu_desc: 'Please take the time to read the Terms of Service before participating in the chat. Failure to comply with the ToS will result in your exclusion from the site.',
  cgu_head_1: "General Terms of service (ToS)",
  cgu_text_1: "<li>You must be at least 18 years old to access this site.</li>\n                <li>No chat participation in the presence of children and no dialogue concerning children.</li>\n                <li>Stay courteous and respectful to other users. No vulgarity will be tolerated. </li>\n                <li>Do not be prescriptive with women and couples, leave them the initiative. </li>\n                <li>Exchanging email addresses, Skype or Internet sites at the room in prohibited. The exchanges must be done in private messages.</li>\n                <li>Write lowercase according to the basic rules of grammar and spelling. </li>\n                <li>Flood is forbidden (repetition of words on several lines).</li>\n                <li>Under no circumstances can a single man use the gender \"Female\" on his profile (except transvestites).</li>\n                <li>Do not check the chat while driving a vehicle.</li>",
  cgu_head_2: "What is BobTV?",
  cgu_text_2: "<li>BobTV is an adult-only exhibition site. Nudity and sexual practices are tolerated within the limits of good morals and legislation.</li>\n                <li>You are free:\n                    <div>- to show yourself in cam or not,</div>\n                    <div>- to be naked or not.</div>\n                </li>\n                <li>BobTV is a sharing site. Your communication must remain friendly and respectful.\n                    Insults, criticism, polemics or mockery and are not tolerated. Share moments of\n                    pleasure, relaxation and humor but in no way your privacy. Leave your convictions, your\n                    family, your worries and your woes outside the site.</li>\n                <li>BobTV is a community site. Express yourself and broadcast freely, without monopolizing\n                    the chat, you have to share it. Write complete sentences correctly, without SMS language.\n                    The parts of sentences posted on several lines are assimilated to spam. A font with too\n                    bright color or large size is aggressive, stay discreet.</li>",
  cgu_head_3: "How it works?",
  cgu_text_3: "<li>Click on the nickname in the list of connected users to open their webcam.</li>\n                <li>Select your audio and video sources in your browser settings by clicking on the small \"camera\" icon in the top bar of your browser.</li>\n                <li>Set the % of page zoom in your browser settings or with Ctrl key and mouse wheel / Ctrl key and + or - keys on your keyboard.</li>\n                <li>To stream your audio, click on the \"microphone\" button in your webcam window.</li>\n                <li>Users with a speaker icon in front of their nickname are those who broadcast their audio.\n                    Open their webcam window and click on the \"speaker\" icon to listen to them.</li>\n                <li>Keep the scroll bar down to see the text scroll automatically.</li>\n                <li>A menu of functions is accessible by a right click on the nicks in the list of connected\n                    users and at the text chat.</li>\n                <li>Sort the list of connected users from the menu indicated by 3 vertical orange dots at\n                    the top of the connected list.</li>\n                <li>4 sizes of webcams are available from the webcams window: small (default), medium,\n                    large and full screen (XXL members only). </li>\n                <li>You may hide your own webcam frame with the \"camera\" button to the left of the text\n                    input form. Your webcam will still be visible to everyone.</li>\n                <li>In a free mode you can watch one webcam at time for 60 minutes per 24 hours on each room.</li>\n                <li>XXL members have their nickname in bold in the list of connected users.</li>",
  cgu_head_4: "Principles of collective moderation",
  cgu_text_4: "<li>XXL members are in charge of moderating the rooms and enforcing the ToS.</li>\n                <li>Moderation is based on the principle of a collective exclusion request (\"Exclude\" link\n                    in the right-click menu on the list of connected users).</li>\n                <li>Any user who does not respect the ToS will be disconnected from the room and forbidden\n                    to access 24 hours or more.</li>",
  cgu_good_chat: 'The chat rooms are compatible with:',
  receive_password_text: 'Enter your email address or nick to receive your password immediately',
  congratulations: 'Congratulations!',
  registration_back: 'Back',
  enter_sms_activation_code: 'Enter the activation code you received by SMS.',
  enter_activation_code_text: function enter_activation_code_text(email) {
    return "Enter the activation code you received by email to your email <span class=\"underline\">".concat(email, "</span> or click on the activation link at the message we sent.");
  },
  enter_activation_code_text_min: 'If you do not receive this email immediately, check the "spam" folder of your mailbox and mark this message as "non-spam". If you can not find this email, <a href="#" id="send-sms">request an SMS</a> to receive the activation code.',
  receive_sms_with_code: 'Receive an SMS with the activation code.',
  enter_phone_to_receive_sms: 'Enter your mobile phone number to receive an SMS activation code.',
  enter_as_anonymous: 'Enter as anonymous',
  multi_rooms_join: 'Join',
  multi_rooms_join_full: 'Join the multi rooms',
  multi_rooms_quit: 'Quit',
  multi_rooms_quit_full: 'Quit the multi rooms',
  notifications: 'notifications',
  tip: function tip(amount) {
    return "has sent you ".concat(amount, " ").concat(amount === '1' ? 'token!' : 'tokens!');
  },
  tip_private: function tip_private(sender, amount) {
    var nick = (0, _utils.escape)(sender);
    if (parseInt(amount) === 1) return "".concat(nick, " has sent you 1 token!");else return "".concat(nick, " has sent you ").concat(amount, " tokens!");
  },
  tip_sent: 'You have sent %1 tokens to',
  tip_private_sent: function tip_private_sent(recpient, amount) {
    var nick = (0, _utils.escape)(recpient);
    if (parseInt(amount) === 1) return "You have sent 1 token to ".concat(nick, ".");else return "You have sent ".concat(amount, " tokens to ").concat(nick, ".");
  },
  gift: 'has sent you a virtual gift!',
  new_follower: 'You have a new follower',
  guestbook_message: 'You have a new message at your Guest book from',
  message: 'has sent you a new message.',
  membership_gift: 'has sent you an XXL membership for %1 days!',
  membership_gift_public: 'has given an XXL membership to',
  followed_user_is_online: 'just connected to the room',
  user_membership_expired: 'Your XXL membership has expired at %1. Renew now!',
  user_membership_almost_expired: 'Your XXL membership will expire at %1. Renew now!',
  error: "It looks like we’re having issues",
  submit_error: "Submith crash report",
  submit_success: "Your feedback has been sent. Thank you! Please reload the page (F5 | ⌘+R)",
  just_reload: "...or just",
  reload_link: "reload the page",
  empty_notifications: "No notifications at the moment.",
  addToHomescreen: 'Add BobTV to Home screen',
  removeApp: "To remove/reinstall bobTV at your desktop copy/paste the following URL at your address bar:",
  muteCountdown: function muteCountdown(minutes) {
    return "Following your non-compliance with the T&Cs, you can no longer write for ".concat(minutes, " minutes.");
  },
  muted_notification: 'has been censored for one hour for disrespecting the T&C.',
  unmuted_notification: 'has been uncensored.',
  recordMessage: 'Your video clip will be published at the Wall in a few minutes.',
  streamRecordError: 'There was a problem with recording of your video clip.',
  XXLBannerText: 'You must be an XXL member to watch full video.',
  XXLBannerButton: 'Become an XXL member',
  confirmRecordText: "You are going to record a video clip which will be immediately published on \"The Wall\" of BobTV. The duration of the recording will be 60 seconds but you can interrupt it only after 10 seconds.",
  confirmPhotoText: "You are going to take a picture which will be immediately published on \"The Wall\" of BobTV. ",
  confirm: "Confirm"
};